import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/app";
import {
  putWorkingDaysFailure,
  putWorkingDaysSuccess,
} from "../slices/features/workingDays";
import { RequestTypes } from "../types";

const appservice = new AppService();

function* putWorkingDaysSaga(action: any) {
  const { payload } = action;
  const { id, data } = payload;
  try {
    const baseUrl: string = yield select(getBaseUrl);

    const response: AxiosResponse<any> = yield call(
      appservice.putWorkingDays,
      baseUrl,
      id,
      data
    );

    yield put(putWorkingDaysSuccess({ ...response }));

    payload?.cbSuccess && payload?.cbSuccess(response);
  } catch (error: any) {
    const { statusCode, statusText } = error;

    const message = error?.data?.errors?.message;

    payload?.cbFailure && payload?.cbFailure(message);

    yield put(putWorkingDaysFailure({ statusCode, statusText }));
  }
}

export function* watchPutWorkingDays() {
  yield takeLatest(RequestTypes.PUT_WORKING_DAYS_REQUEST, putWorkingDaysSaga);
}
